import { useAuthContext } from "@acto/web-common/auth";
import { useTranslations } from "@acto/web-common/locales";
import { SolidCtaButton } from "@acto/taskpane/field-sales-2/components/primitives/SheetCta";
import { SecondaryButton } from "@acto/taskpane/field-sales-2/components/primitives/SecondaryButton";
import { PreAuthScreen } from "./PreAuthScreen";

const WelcomePage = () => {
  const { login } = useAuthContext();
  const t = useTranslations("welcome");

  const bookDemo = () => {
    window.open("https://www.heyacto.com/contact", "_blank", "noopener,noreferrer");
  };

  return (
    <PreAuthScreen
      actions={
        <>
          <SolidCtaButton type="button" onClick={login}>
            {t("login")}
          </SolidCtaButton>
          <SecondaryButton type="button" onClick={bookDemo}>
            {t("bookDemo")}
          </SecondaryButton>
        </>
      }
    >
      <p>{t("description")}</p>
      <p>{t("dontHaveAccount")}</p>
    </PreAuthScreen>
  );
};

export default WelcomePage;
